import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Metadata} from "../models/metadata";
import { MetadataService } from "../services/metadata.service";
import { Observable } from "rxjs";

@Injectable()
export class MetadataByCountryResolver implements Resolve<Metadata[]> {
    constructor(private metadataService: MetadataService) {
    }
    resolve(route: ActivatedRouteSnapshot): Observable<Metadata[]> {
        const countryCode: string = route.params["countryCode"];
        return this.metadataService.getAllMetadataByCountry(countryCode);
    }
}
